import { request } from "./groups";

export type MediaRequestKind = "photo" | "video" | "voice";
export type MediaTemporaryMode = "normal" | "view_once";
export type MediaRequestStatus =
  | "pending"
  | "accepted"
  | "declined"
  | "fulfilled"
  | "cancelled"
  | "expired";

export type MediaRequestItem = {
  id: string;
  requestKind: MediaRequestKind;
  temporaryMode: MediaTemporaryMode;
  status: MediaRequestStatus;
  requesterUserId: string;
  targetUserId?: string | null;
  originGroupId?: string | null;
  originActivityId?: string | null;
  conversationId?: string | null;
  requesterNote?: string | null;
  responseNote?: string | null;
  requestedAt?: string;
  respondedAt?: string | null;
  fulfilledAt?: string | null;
  expiresAt?: string | null;
};

export async function createMediaRequest(payload: {
  targetUserId?: string | number | null;
  requestKind: MediaRequestKind;
  temporaryMode?: MediaTemporaryMode;
  originGroupId?: string | null;
  originActivityId?: string | null;
  conversationId?: string | null;
  note?: string;
}) {
  return request<{ ok: boolean; item: MediaRequestItem }>("/messages/media-requests", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function listMediaRequests(params?: {
  status?: MediaRequestStatus;
  conversationId?: string;
}) {
  const qs = new URLSearchParams();

  if (params?.status) {
    qs.set("status", params.status);
  }

  if (params?.conversationId) {
    qs.set("conversationId", params.conversationId);
  }

  const suffix = qs.toString() ? `?${qs.toString()}` : "";

  return request<{ ok: boolean; items: MediaRequestItem[] }>(
    `/messages/media-requests${suffix}`
  );
}

export async function respondMediaRequest(
  id: string,
  payload: {
    action: "accepted" | "declined" | "cancelled";
    note?: string;
  }
) {
  return request<{ ok: boolean; id: string; status: MediaRequestStatus }>(
    `/messages/media-requests/${encodeURIComponent(id)}/respond`,
    {
      method: "POST",
      body: JSON.stringify(payload),
    }
  );
}

export async function fulfillMediaRequest(id: string) {
  return request<{ ok: boolean; id: string; status: MediaRequestStatus }>(
    `/messages/media-requests/${encodeURIComponent(id)}/fulfilled`,
    {
      method: "POST",
      body: JSON.stringify({}),
    }
  );
}
